module.exports = __webpack_public_path__ + "img/banner6.73f87801.png";